import React, { useEffect, useRef, useState } from 'react';
import './MoreBtn.scss';
import { Button } from 'primereact/button';
import CustomTooltip from '../tooltip/CustomTooltip';
import { Menu } from 'primereact/menu';

interface MoreBtnProps {
  children: React.ReactNode;
  rowId: number;
  /**
   * Klucz i18n na tooltip. Domyślne „Szczegóły" pasuje do list, gdzie menu prowadzi do podglądu
   * wiersza; tam, gdzie kryje same akcje (zespół), wołający podaje własną etykietę.
   */
  tooltipText?: string;
}

const MoreBtn: React.FC<MoreBtnProps> = ({ children, rowId, tooltipText = 'viewDetails' }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef<Menu>(null);

  const toggleMenu = (event: any) => {
    setIsMenuOpen(!isMenuOpen);

    if (menuRef.current) {
      menuRef.current.toggle(event);
    }
  };

  const handleScroll = () => {
    if (menuRef.current) {
      menuRef.current.hide({} as React.SyntheticEvent);
    }
  };

  useEffect(() => {
    // Close the popup on ANY scroll — the page scroll (`.layout__right`) OR an inner
    // scroll container such as a SimpleBar table. Capture phase catches scroll events
    // from any element (scroll events don't bubble), so the menu no longer "hangs" when
    // the table it lives in scrolls internally.
    document.addEventListener('scroll', handleScroll, true);
    return () => {
      document.removeEventListener('scroll', handleScroll, true);
    };
  }, [isMenuOpen]);

  return (
    <div className="more-action">
      <Button id={`more-btn-${rowId}`} className="action-btn action-btn--more" onClick={toggleMenu}>
        <span className="ico--more ico--xs" />
      </Button>
      <CustomTooltip tooltipText={tooltipText} targetRef={`more-btn-${rowId}`} />
      <Menu
        ref={menuRef}
        model={[{ template: children }]}
        popup
        appendTo={document.body}
        popupAlignment="right"
        onHide={() => setIsMenuOpen(false)}
      />
    </div>
  );
};

export default MoreBtn;
